import { C as Cart } from "./cart-DY-kXn0p.js";
import "./utils-D8tYCXRD.js";
import "./replacePersonalCansSection-BoLk9oIv.js";
class MainCart extends Cart {
  constructor() {
    super();
    this.cartSectionId = null;
    this.currentNote = "";
    this.isUpdatingInput = false;
    this.handleAgeGate = this.handleAgeGate.bind(this);
    this.boundHandleUpdateCartSection = this.handleUpdateCartSection.bind(this);
    window.setTimeout(() => {
      this.classList.remove("is-loading");
    }, 1500);
  }
  connectedCallback() {
    this.handleInitialization();
    super.connectedCallback();
  }
  handleInitialization() {
    this.setCartSectionId();
    this.setEventListeners();
    this.initGiftMessage();
  }
  setCartSectionId() {
    const sectionWrapper = this.closest(".shopify-section");
    if (!sectionWrapper) {
      console.error("Cart: Cart section not found.");
      return;
    }
    const idString = sectionWrapper.id;
    const sectionId = idString.replace("shopify-section-", "");
    this.cartSectionId = sectionId;
  }
  setEventListeners() {
    this.cleanupEventListeners();
    document.addEventListener(
      "cart:updated",
      this.boundHandleUpdateCartSection
    );
    const ageGatedCheckoutForm = this.querySelector('[js-main-cart="form"]');
    if (ageGatedCheckoutForm) {
      ageGatedCheckoutForm.addEventListener(
        "submit",
        this.handleAgeGate.bind(this)
      );
    }
  }
  cleanupEventListeners() {
    document.removeEventListener(
      "cart:updated",
      this.boundHandleUpdateCartSection
    );
    const ageGatedCheckoutForm = this.querySelector('[js-main-cart="form"]');
    if (ageGatedCheckoutForm) {
      ageGatedCheckoutForm.removeEventListener(
        "submit",
        this.handleAgeGate.bind(this)
      );
    }
  }
  // Function to remove emojis using comprehensive regex pattern
  stripEmojis(text) {
    if (!text)
      return "";
    const emojiRegex = /[\u{1F000}-\u{1FFFF}]|[\u{2600}-\u{27BF}]|[\u{2300}-\u{23FF}]|[\u{2B50}]|[\u{2B55}]|[\u{200D}]|[\u{FE0F}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA00}-\u{1FAFF}]|[\u{2702}-\u{27B0}]|[\u{24C2}-\u{1F251}]|[\u{1F000}-\u{1FFFD}]|[\u{1F3FB}-\u{1F3FF}]|[\u{1F9B0}-\u{1F9B3}]|[\u{2700}-\u{27BF}]|[\u{2600}-\u{26FF}]/gu;
    const originalText = text;
    let cleanedText = text.replace(emojiRegex, "");
    const chars = cleanedText.split("");
    for (let i = 0; i < chars.length; i++) {
      if (chars[i].charCodeAt(0) >= 8e3) {
        chars[i] = "";
      }
    }
    cleanedText = chars.join("");
    if (originalText !== cleanedText) {
      this.showEmojiWarning();
      return cleanedText;
    }
    return cleanedText;
  }
  // Function to show emoji warning
  showEmojiWarning() {
    const warningElement = document.querySelector(
      ".gift-message-emoji-error"
    );
    if (warningElement) {
      warningElement.style.display = "block";
      setTimeout(() => {
        warningElement.style.display = "none";
      }, 5e3);
    } else {
      const noteContainer = document.querySelector(".main-cart__note");
      if (noteContainer) {
        const emojiWarning = document.createElement("div");
        emojiWarning.className = "gift-message-emoji-error";
        emojiWarning.innerHTML = `
          <p>
            Emojis are not supported and have been removed from your text.
          </p>
        `;
        emojiWarning.style.display = "block";
        emojiWarning.style.marginTop = "10px";
        emojiWarning.style.marginBottom = "10px";
        emojiWarning.style.padding = "10px 15px";
        emojiWarning.style.backgroundColor = "#fff2f2";
        emojiWarning.style.border = "1px solid #ff5252";
        emojiWarning.style.borderRadius = "4px";
        emojiWarning.style.color = "#ff0000";
        emojiWarning.style.fontWeight = "bold";
        emojiWarning.style.fontSize = "14px";
        emojiWarning.style.zIndex = "100";
        noteContainer.insertAdjacentElement("afterend", emojiWarning);
        setTimeout(() => {
          emojiWarning.style.display = "none";
        }, 5e3);
      }
    }
  }
  initGiftMessage() {
    const noteContainer = document.querySelector(".main-cart__note");
    const noteInput = document.querySelector(
      ".main-cart__note-input"
    );
    const existingButton = document.querySelector(
      '[js-main-cart="noteAddButton"]'
    );
    if (!noteContainer || !noteInput)
      return;
    this.currentNote = noteInput.value || "";
    if (existingButton) {
      existingButton.style.display = "none";
    }
    const formContainer = noteContainer.parentElement;
    if (!formContainer)
      return;
    this.createCharCounter(noteInput, formContainer, noteContainer);
    this.createButtonsContainer(formContainer, noteContainer);
    this.createMessageDisplay(formContainer, noteContainer);
    this.updateUIState();
    noteInput.addEventListener("input", (e) => {
      if (this.isUpdatingInput)
        return;
      const target = e.target;
      const originalValue = target.value;
      const cleanedValue = this.stripEmojis(originalValue);
      if (cleanedValue !== originalValue) {
        target.value = cleanedValue;
      }
      if (target.value.length > 128) {
        target.value = target.value.substring(0, 128);
      }
      this.updateCharCounter(target);
      this.updateUIState();
    });
    noteInput.addEventListener("paste", (event) => {
      const input = event.target;
      if (!input)
        return;
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedText = (clipboardData == null ? void 0 : clipboardData.getData("text")) || "";
      const cleanedValue = this.stripEmojis(pastedText);
      if (cleanedValue !== pastedText) {
        event.preventDefault();
        const startPos = input.selectionStart || 0;
        const endPos = input.selectionEnd || 0;
        const beforeText = input.value.substring(0, startPos);
        const afterText = input.value.substring(endPos);
        const newValue = beforeText + cleanedValue + afterText;
        const finalValue = newValue.length > 128 ? newValue.substring(0, 128) : newValue;
        input.value = finalValue;
        const newCursorPos = Math.min(startPos + cleanedValue.length, 128);
        input.selectionStart = input.selectionEnd = newCursorPos;
        this.updateCharCounter(input);
        this.updateUIState();
      }
    });
    this.attachButtonListeners();
  }
  createCharCounter(noteInput, parent, insertAfter) {
    const charCounter = document.querySelector(".gift-message-counter");
    if (!charCounter) {
      const counterEl = document.createElement("div");
      counterEl.className = "gift-message-counter";
      counterEl.textContent = `${noteInput.value.length}/128`;
      insertAfter.insertAdjacentElement("beforebegin", counterEl);
    }
  }
  createButtonsContainer(parent, insertAfter) {
    var _a, _b;
    const buttonsContainer = document.querySelector(".gift-message-buttons");
    if (!buttonsContainer) {
      const buttonsEl = document.createElement("div");
      buttonsEl.className = "gift-message-buttons";
      const trashIcon = ((_b = (_a = window.themeVars) == null ? void 0 : _a.icons) == null ? void 0 : _b.trash) || "";
      buttonsEl.innerHTML = `
        <button type="button" class="gift-message-add btn btn-black btn-small">
          Save
        </button>
        <div class="gift-message-actions" style="display: none;">
          <button type="button" class="gift-message-update btn btn-black btn-small">
            Update
          </button>
          <button type="button" class="gift-message-remove btn btn-black btn-small">
            ${trashIcon}
          </button>
        </div>
      `;
      insertAfter.insertAdjacentElement("afterend", buttonsEl);
    }
  }
  createMessageDisplay(parent, insertAfter) {
    const messageDisplay = document.querySelector(".gift-message-display");
    if (!messageDisplay) {
      const displayEl = document.createElement("div");
      displayEl.className = "gift-message-display";
      displayEl.style.display = "none";
      displayEl.innerHTML = `
        <div class="gift-message-preview">
          <strong>Gift Message:</strong>
          <span class="gift-message-text"></span>
        </div>
      `;
      const buttonsContainer = document.querySelector(".gift-message-buttons");
      if (buttonsContainer) {
        buttonsContainer.insertAdjacentElement("afterend", displayEl);
      } else {
        insertAfter.insertAdjacentElement("afterend", displayEl);
      }
    }
  }
  attachButtonListeners() {
    document.addEventListener("click", (e) => {
      const target = e.target;
      const button = target.closest(
        ".gift-message-add, .gift-message-update, .gift-message-remove"
      );
      if (button) {
        e.preventDefault();
        if (button.classList.contains("gift-message-add")) {
          this.addGiftMessage();
        } else if (button.classList.contains("gift-message-update")) {
          this.updateGiftMessage();
        } else if (button.classList.contains("gift-message-remove")) {
          this.removeGiftMessage();
        }
      }
    });
  }
  updateUIState() {
    const noteInput = document.querySelector(
      ".main-cart__note-input"
    );
    const addButton = document.querySelector(
      ".gift-message-add"
    );
    const actionsContainer = document.querySelector(
      ".gift-message-actions"
    );
    const messageDisplay = document.querySelector(
      ".gift-message-display"
    );
    const messageText = document.querySelector(
      ".gift-message-text"
    );
    const updateButton = document.querySelector(
      ".gift-message-update"
    );
    const cartContainer = document.querySelector(".main-cart");
    if (!noteInput || !addButton || !actionsContainer || !messageDisplay || !messageText || !updateButton || !cartContainer)
      return;
    const hasCurrentNote = this.currentNote.trim().length > 0;
    const hasInputValue = noteInput.value.trim().length > 0;
    if (hasCurrentNote) {
      if (!hasInputValue) {
        this.isUpdatingInput = true;
        noteInput.value = this.currentNote;
        this.updateCharCounter(noteInput);
        this.isUpdatingInput = false;
      }
      addButton.style.display = "none";
      actionsContainer.style.display = "flex";
      messageDisplay.style.display = "block";
      messageText.textContent = this.currentNote;
      updateButton.disabled = false;
      cartContainer.classList.add("has-visible-gift-buttons");
    } else {
      if (hasInputValue) {
        addButton.style.display = "block";
        addButton.disabled = false;
        cartContainer.classList.add("has-visible-gift-buttons");
      } else {
        addButton.style.display = "none";
        cartContainer.classList.remove("has-visible-gift-buttons");
      }
      actionsContainer.style.display = "none";
      messageDisplay.style.display = "none";
    }
  }
  updateCharCounter(noteInput) {
    const charCounter = document.querySelector(".gift-message-counter");
    if (charCounter) {
      charCounter.textContent = `${noteInput.value.length}/128`;
    }
  }
  addGiftMessage() {
    const noteInput = document.querySelector(
      ".main-cart__note-input"
    );
    if (noteInput && noteInput.value.trim()) {
      this.currentNote = noteInput.value.trim();
      super.addNote(this.currentNote);
      this.updateUIState();
    }
  }
  updateGiftMessage() {
    const noteInput = document.querySelector(
      ".main-cart__note-input"
    );
    if (noteInput && noteInput.value.trim()) {
      this.currentNote = noteInput.value.trim();
      super.addNote(this.currentNote);
      this.updateUIState();
    }
  }
  removeGiftMessage() {
    const noteInput = document.querySelector(
      ".main-cart__note-input"
    );
    if (noteInput) {
      this.isUpdatingInput = true;
      noteInput.value = "";
      this.currentNote = "";
      this.updateCharCounter(noteInput);
      this.isUpdatingInput = false;
      super.addNote("");
      this.updateUIState();
    }
  }
  changeCartItemQuantity(id, quantity) {
    super.changeItemQuantity(id, quantity);
  }
  async handleUpdateCartSection() {
    try {
      this.cleanupEventListeners();
      const existingUpsellElement = this.querySelector("uwp-cart-upsell");
      const url = `${window.themeVars.routes.cart}?section_id=${this.cartSectionId}`;
      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, "text/html");
      const newSection = html.querySelector("uwp-main-cart");
      if (!newSection) {
        console.error("Cart: New section not found.");
        return;
      }
      this.innerHTML = newSection.innerHTML;
      if (existingUpsellElement) {
        const newCartUpsellElement = this.querySelector("uwp-cart-upsell");
        if (newCartUpsellElement) {
          newCartUpsellElement.replaceWith(existingUpsellElement);
        } else {
          this.appendChild(existingUpsellElement);
        }
      }
      this.handleInitialization();
      setTimeout(() => {
        const cartEmpty = this.cartData.item_count === 0;
        if (cartEmpty) {
          this.classList.add("is-empty");
          return;
        }
        this.classList.remove("is-empty");
      }, 50);
      window.setTimeout(() => {
        this.classList.remove("is-loading");
      }, 1500);
    } catch (error) {
      console.error(error);
    }
  }
  handleAgeGate(event) {
    event == null ? void 0 : event.preventDefault();
    const ageGate = document.querySelector(
      "uwp-age-gate[modal-name='age-gate']"
    );
    const isLocalStorageSet = (ageGate == null ? void 0 : ageGate.isAgeApproved()) || false;
    if (isLocalStorageSet) {
      this.redirectToCheckout();
      return;
    }
    document.addEventListener(
      "ageGate:approved",
      () => this.redirectToCheckout()
    );
    ageGate == null ? void 0 : ageGate.showAgeGate();
  }
  redirectToCheckout() {
    window.location.href = "/checkout";
  }
}
customElements.define("uwp-main-cart", MainCart);
